import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  TableFooter,
  TableRow,
  TablePagination
} from '@material-ui/core';

function CTableFooter (props) {
  return (
    <TableFooter>
      <TableRow>
        <TablePagination
          rowsPerPageOptions={[20, 30, 50]}
          count={props.count}
          rowsPerPage={props.rowsPerPage}
          page={props.currentPage}
          onChangePage={props.onChangePage}
          onChangeRowsPerPage={props.onChangeRowsPerPage}
        />
      </TableRow>
    </TableFooter>
  );
}

CTableFooter.propTypes = {
  count: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired
};

export default memo(CTableFooter);
